import { render, staticRenderFns } from "./EditarComanda.vue?vue&type=template&id=687704f8&scoped=true"
import script from "./EditarComanda.vue?vue&type=script&lang=js"
export * from "./EditarComanda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687704f8",
  null
  
)

export default component.exports